import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgbAlertModule, NgbDatepickerModule, NgbDropdownModule, NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { InputPriceFormatModule } from 'angular-input-price-format';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DndModule } from 'ngx-drag-drop';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxPaginationModule } from 'ngx-pagination';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ComponentsModule } from 'src/app/components/components.module';
import { UIModule } from 'src/app/shared/ui/ui.module';

import { NgOtpInputModule } from 'ng-otp-input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CoreModule } from 'src/app/core/core.module';
import { OrdersModule } from '../sales/orders/orders.module';
import { ListComponent } from './list/list.component';
import { MerchantCaptchaCheckComponent } from './merchant-captcha-check/merchant-captcha-check.component';
import { MerchantHomeComponent } from './merchant-home/merchant-home.component';
import { MerchantListOfCountriesComponent } from './merchant-list-of-countries/merchant-list-of-countries.component';
import { MerchantSignupComponent } from './merchant-signup/merchant-signup.component';
import { MerchantlistComponent } from './merchantlist/merchantlist.component';
import { MerchantsDetailsComponent } from './merchants-details/merchants-details.component';
import { MerchantsRoutingModule } from './merchants-routing.module';
import { QuicksettingComponent } from './quicksetting/quicksetting.component';
import { ArchivedMerchantsComponent } from './list/archived-merchants/archived-merchants.component';
import { OnboarderMerchantComponent } from './list/onboarder-merchant/onboarder-merchant.component';
import { InternalMerchantComponent } from './list/internal-merchant/internal-merchant.component';
import { QuickActionsComponent } from './list/quick-actions/quick-actions.component';
import {EmployeeSupportPinComponent} from '../employee-support-pin/employee-support-pin.component';
import { AdminOrderDetailsComponent } from './admin-order-details/admin-order-details.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AdminTransactionsDetailsComponent } from './admin-transactions-details/admin-transactions-details.component';

@NgModule({
  declarations: [
    ListComponent,
    MerchantlistComponent,
    QuicksettingComponent,
    MerchantHomeComponent,
    MerchantsDetailsComponent,
    MerchantSignupComponent,
    MerchantListOfCountriesComponent,
    MerchantCaptchaCheckComponent,
    ArchivedMerchantsComponent,
    OnboarderMerchantComponent,
    InternalMerchantComponent,
    EmployeeSupportPinComponent,
    AdminOrderDetailsComponent,
    AdminTransactionsDetailsComponent,
    QuickActionsComponent
    // ListOfCountriesComponent,
    // CaptchaCheckComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    UIModule,
    NgApexchartsModule,
    NgbDatepickerModule,
    NgxIntlTelInputModule,
    NgbAlertModule,
    NgOtpInputModule,
    NgbModalModule,
    CKEditorModule,
    DndModule,
    NgbDropdownModule,
    NgxPaginationModule,
    DataTablesModule,
    NgxDropzoneModule,
    ComponentsModule,
    InputPriceFormatModule,
    NgSelectModule,
    NgbDropdownModule,
    NgbModule,
    UiSwitchModule,
    NgMultiSelectDropDownModule.forRoot(),
    MerchantsRoutingModule,
    OrdersModule,
    Daterangepicker,
    NgxDaterangepickerMd.forRoot(),
  ]
})
export class MerchantsModule { }
